import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import useAuth from "src/hooks/useAuth";
import useMutation from "src/hooks/useMutation";
import useNotification from "src/hooks/notification";
import ScanOrEnterModal from "src/views/inventory/requests/orders/ScanOrEnterModal";
import ScanOutModal from "src/views/inventory/requests/orders/ScanOutModal";
import StagingModal from "./StagingModal";
import { UPDATE_INVENTORY_ITEM_MUTATION } from "src/constants/graphql/mutations";

export default function StagingSection({ asset, inventoryItem, inventoryRequest }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const [openModal, setOpenModal] = useState(false);
  const [openScanOrEnterModal, setOpenScanOrEnterModal] = useState(false);
  const [openScanModal, setOpenScanModal] = useState(false);

  const [updateItem] = useMutation(UPDATE_INVENTORY_ITEM_MUTATION);
  const { notifySuccess } = useNotification();

  const markAsStaged = async () => {
    try {
      await updateItem({
        variables: {
          id: inventoryItem.id,
          assetId: inventoryItem.assetId,
          quantity: inventoryItem.quantity,
          stagedStatus: true,
        },
      });
      notifySuccess("Item staged successfully");
    } catch (error) {
      console.error("Error marking item as staged:", error);
    }
  };

  const handleClick = () => {
    if (settings?.scan_out_modal) {
      setOpenScanOrEnterModal(true);
    } else {
      setOpenModal(true);
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          <Box mb={1}>
            <Typography fontWeight={500} fontSize={18}>
              Staging Area
            </Typography>
          </Box>
          {inventoryItem.stagedStatus ? (
            <Box bgcolor="#D5F5D5" py={1} borderRadius={1} textAlign="center" fontWeight={500}>
              Staging Complete
            </Box>
          ) : (
            <Button fullWidth variant="outlined" color="primary" onClick={handleClick}>
              Scan to Staging Area
            </Button>
          )}
        </CardContent>
      </Card>

      {openModal && (
        <StagingModal
          open={openModal}
          asset={asset}
          item={inventoryItem}
          onClose={() => setOpenModal(false)}
          onSuccess={markAsStaged}
        />
      )}

      {openScanOrEnterModal && (
        <ScanOrEnterModal
          asset={asset}
          onClose={() => setOpenScanOrEnterModal(false)}
          openScanModal={() => setOpenScanModal(true)}
          markAsPicked={async () => {
            setOpenScanOrEnterModal(false);
            setOpenModal(true);
          }}
          enableSuccessNotification={false}
        />
      )}

      {openScanModal && (
        <ScanOutModal
          asset={asset}
          onClose={() => setOpenScanModal(false)}
          onScanComplete={async () => {
            setOpenScanModal(false);
            setOpenModal(true);
          }}
        />
      )}
    </>
  );
}
